import React, { ReactElement, useState } from 'react';
import { Details, Loader } from 'idsk-react-components';
import Layout from '../Layout';
import {
  SubjektBezPripomienokList,
  useSubjektBezPripomienokListPage,
} from '../../module/SubjektBezPripomienokList';
import './hromadnaPripomienkaListPage.scss';
import { PripomienkaList } from '../../module/PripomienkaList';
import Uuid from '../../model/Uuid';
import ClassType from '../../model/pripomienka/ClassType';
import useFilterData from '../../module/PripomienkaList/hooks/useFilterData';
import Filter from '../../module/Filter/Filter';
import useFilterPripomienkaList from '../../module/PripomienkaList/hooks/useFilterPripomienkaList';
import SecuredPage from '../../module/SecuredPage';
import emptyFilter from '../../module/PripomienkaList/emptyFilter';

export default (): ReactElement => {
  const [assignedList, setAssignedList] = useState<Array<Uuid>>([]);

  const {
    subjektBezPripomienokListPage,
    subjektStatus,
    subjPageNumberFromUrl,
    reloadSubjektBezPripomienokList,
  } = useSubjektBezPripomienokListPage();

  const {
    filterData,
    filterDataStatus,
    reloadFilterData,
  } = useFilterData(ClassType.HROMADNA_PRIPOMIENKA);

  const {
    pripomienkaListPage,
    pripomienkaStatus,
    pripomienkaPageNumberFromUrl,
    reloadPripomienkyList,
    filter,
  } = useFilterPripomienkaList(ClassType.HROMADNA_PRIPOMIENKA);

  return (
    <Layout
      assignedList={assignedList}
      setAssignedList={setAssignedList}
      reloadSubjektBezPripomienokList={reloadSubjektBezPripomienokList}
      reloadPripomienkyList={reloadPripomienkyList}
      reloadFilterData={reloadFilterData}
      isHromadna
    >
      <SecuredPage
        requestStatuses={[subjektStatus?.responseCode, pripomienkaStatus?.responseCode]}
      >
        <>
          {filterData && (
            <Loader loading={filterDataStatus.loading}>
              <Filter
                isHromadna
                filter={filter}
                filterData={filterData}
              />
            </Loader>
          )}
          <Details summary="Subjekty bez pripomienok">
            <SubjektBezPripomienokList
              page={subjektBezPripomienokListPage}
              status={subjektStatus}
              pageNumberFromUrl={subjPageNumberFromUrl}
              reloadSubjektBezPripomienokList={reloadSubjektBezPripomienokList}
            />
          </Details>
          <PripomienkaList
            page={pripomienkaListPage}
            status={pripomienkaStatus}
            pageNumberFromUrl={pripomienkaPageNumberFromUrl}
            assignedList={assignedList}
            setAssignedList={setAssignedList}
            reloadPripomienkaListPage={reloadPripomienkyList}
            reloadFilterData={reloadFilterData}
            isSelectedFilter={JSON.stringify(filter) !== JSON.stringify(emptyFilter)}
          />
        </>
      </SecuredPage>
    </Layout>
  );
};
